import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./Suppliers.module.css"
import plus from "../../../../../Assets/plus.svg"
import ReportBackground from "../../../../../Assets/report.svg"
import run from "../../../../../Assets/run.svg"
import MailLogo from "../../../../../Assets/mail.svg"
import PrintLogo from "../../../../../Assets/print.svg"
import DownloadLogo from "../../../../../Assets/down.svg"
import BackLogo from "../../../../../Assets/back.svg"
import RotatingLogo from '../../../../../Assets/rotating-logo.png'
import EyeIcon from "../../../../../Assets/new-eye.svg"
import DeleteIcon from "../../../../../Assets/new-delete.svg"
import PencilIcon from "../../../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../../../Budget/Budget Dashboard/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../../../Assets/download1.svg"
import upload from "../../../../../Assets/upload.svg"
import logo from "../../../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const Suppliers = () => {
  const location = useLocation();
  const [noData, setNoData] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [filteredSuppliers, setFilteredSuppliers] = useState([]);
  const [load, setLoad] = useState(false);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData45, setTableData45] = useState([]);
  const [totalDebit, setTotalDebit] = useState('');
  const [totalCredit, setTotalCredit] = useState('');
  const [allAccounts, setAllAccounts] = useState([]);
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState([]);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [currentMonth, setCurrentMonth] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [admin, setAdmin] = useState('');

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');

      if (value !== null) {
        setBearer(value);
      }

      if (value1 !== null) {
        setUser(value1);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);
        setCurrentMonth(date);

        const startOfDateRange = new Date(1900, 0, 1);
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
      }
      if (admins !== null) {
        setAdmin(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  // Fetch all suppliers from API
  const fetchSuppliers = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/beneficiary`, {
        headers
      });

      console.log("Suppliers API Response:", response.data);

      let suppliersData = [];

      if (response.data && response.data.data) {
        // Handle different response structures
        if (Array.isArray(response.data.data)) {
          suppliersData = response.data.data;
        }
        else if (response.data.data.data && Array.isArray(response.data.data.data)) {
          suppliersData = response.data.data.data;
        }
        else if (response.data.data.suppliers && Array.isArray(response.data.data.suppliers)) {
          suppliersData = response.data.data.suppliers;
        }
        else if (response.data.data.beneficiaries && Array.isArray(response.data.data.beneficiaries)) {
          suppliersData = response.data.data.beneficiaries;
        }
        else {
          const dataObj = response.data.data;
          const arrayKeys = Object.keys(dataObj).filter(key => Array.isArray(dataObj[key]));
          if (arrayKeys.length > 0) {
            suppliersData = dataObj[arrayKeys[0]];
          } else {
            suppliersData = [dataObj];
          }
        }
      } else if (Array.isArray(response.data)) {
        suppliersData = response.data;
      }

      setSuppliers(suppliersData);
      setFilteredSuppliers(suppliersData);
      setTotalEntries(suppliersData.length);
      setTotalPages(Math.ceil(suppliersData.length / entriesPerPage));
      setCurrentPage(1);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response?.data && error.response?.data.message) {
          if (typeof error.response?.data.message === 'string') {
            errorMessage = error.response?.data.message;
          } else if (Array.isArray(error.response?.data.message)) {
            errorMessage = error.response?.data.message.join('; ');
          }
        }
        setError(errorMessage);
        setSuppliers([]);
        setFilteredSuppliers([]);
        setTotalPages(1);
        setCurrentPage(1);
        setTotalEntries(0);
      }
    } finally {
      setBenLoading(false);
    }
  };

  // Fetch filtered suppliers using Process button API
  const fetchFilteredSuppliers = async () => {
    setBenLoading(true);
    try {
      const params = {
        ...(selectedContinent && { continent_id: selectedContinent }),
        ...(selectedRegion && { region_id: selectedRegion }),
        ...(selectedProvince && { province_id: selectedProvince })
      };

      const response = await axios.get(`${BASE_URL}/beneficiary/get`, {
        headers,
        params
      });

      console.log("Filtered Suppliers API Response:", response.data);

      let suppliersData = [];

      if (response.data && response.data.data) {
        if (Array.isArray(response.data.data)) {
          suppliersData = response.data.data;
        }
        else if (response.data.data.data && Array.isArray(response.data.data.data)) {
          suppliersData = response.data.data.data;
        }
        else if (response.data.data.suppliers && Array.isArray(response.data.data.suppliers)) {
          suppliersData = response.data.data.suppliers;
        }
        else if (response.data.data.beneficiaries && Array.isArray(response.data.data.beneficiaries)) {
          suppliersData = response.data.data.beneficiaries;
        }
        else {
          const dataObj = response.data.data;
          const arrayKeys = Object.keys(dataObj).filter(key => Array.isArray(dataObj[key]));
          if (arrayKeys.length > 0) {
            suppliersData = dataObj[arrayKeys[0]];
          } else {
            suppliersData = [dataObj];
          }
        }
      } else if (Array.isArray(response.data)) {
        suppliersData = response.data;
      }

      setFilteredSuppliers(suppliersData);
      setTotalEntries(suppliersData.length);
      setTotalPages(Math.ceil(suppliersData.length / entriesPerPage));
      setCurrentPage(1);

    } catch (error) {
      console.error("Error fetching filtered suppliers:", error);
      setFilteredSuppliers([]);
      setTotalEntries(0);
      setTotalPages(1);
      setCurrentPage(1);
    } finally {
      setBenLoading(false);
    }
  };

  // Load suppliers automatically on component mount
  useEffect(() => {
    if (bearer) {
      fetchSuppliers();
    }
  }, [bearer]);

  // Handle process button click - uses the filter API
  const handleProcess = () => {
    if (selectedContinent || selectedRegion || selectedProvince) {
      fetchFilteredSuppliers();
    } else {
      // If no filters selected, just reset to show all suppliers
      setFilteredSuppliers(suppliers);
      setTotalEntries(suppliers.length);
      setTotalPages(Math.ceil(suppliers.length / entriesPerPage));
      setCurrentPage(1);
    }
  };

  // Handle search - client-side filtering
  const handleSearch = () => {
    if (!searchTerm.trim()) {
      setFilteredSuppliers(suppliers);
    } else {
      const filtered = suppliers.filter(supplier =>
        supplier?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        supplier?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        supplier?.phone?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        supplier?.created_by?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        supplier?.id?.toString().includes(searchTerm)
      );
      setFilteredSuppliers(filtered);
    }
    setTotalEntries(filteredSuppliers.length);
    setTotalPages(Math.ceil(filteredSuppliers.length / entriesPerPage));
    setCurrentPage(1);
  };

  // Handle Enter key press in search
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  // Update filtered suppliers when search term changes
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredSuppliers(suppliers);
    } else {
      const filtered = suppliers.filter(supplier =>
        supplier?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        supplier?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        supplier?.phone?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        supplier?.created_by?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        supplier?.id?.toString().includes(searchTerm)
      );
      setFilteredSuppliers(filtered);
    }
    setTotalEntries(filteredSuppliers.length);
    setTotalPages(Math.ceil(filteredSuppliers.length / entriesPerPage));
    setCurrentPage(1);
  }, [searchTerm, suppliers]);

  // Pagination handlers
  const handleFirstPage = () => {
    if (currentPage > 1) {
      setCurrentPage(1);
    }
  };

  const handleLastPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(totalPages);
    }
  };

  const handlePageClick = (page) => {
    if (page !== currentPage) {
      setCurrentPage(page);
    }
  };

  // Generate page numbers for display
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);

      if (currentPage <= 3) {
        endPage = maxVisiblePages;
      }
      if (currentPage >= totalPages - 2) {
        startPage = totalPages - maxVisiblePages + 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  // Get current page data
  const getCurrentPageData = () => {
    const startIndex = (currentPage - 1) * entriesPerPage;
    const endIndex = startIndex + entriesPerPage;
    return filteredSuppliers.slice(startIndex, endIndex);
  };

  // Format date function
  function formatDate(dateString) {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  // Fetch continents
  const fetchContinents = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const results = response.data?.data;

      const options = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setSelectOptions(options);
    } catch (error) {
      console.error("Error fetching continents:", error);
      setSelectOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch regions based on selected continent
  const fetchRegions = async (continentId) => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });
      const regionsData = response.data?.data?.regions || response.data?.data || [];

      const options = regionsData.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData3(options);
    } catch (error) {
      console.error("Error fetching regions:", error);
      setTableData3([]);
    } finally {
      setLoad(false);
    }
  };

  // Fetch provinces based on selected region
  const fetchProvinces = async (regionId) => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`, { headers });
      const provincesData = response.data?.data || [];

      const options = provincesData.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData4(options);
    } catch (error) {
      console.error("Error fetching provinces:", error);
      setTableData4([]);
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchContinents();
    }
  }, [bearer]);

  useEffect(() => {
    if (bearer && selectedContinent) {
      fetchRegions(selectedContinent);
    } else {
      setTableData3([]);
      setSelectedRegion('');
      setSelectedProvince('');
    }
  }, [bearer, selectedContinent]);

  useEffect(() => {
    if (bearer && selectedRegion) {
      fetchProvinces(selectedRegion);
    } else {
      setTableData4([]);
      setSelectedProvince('');
    }
  }, [bearer, selectedRegion]);

  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption?.value || '');
    setSelectedRegion('');
    setSelectedProvince('');
  };

  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption?.value || '');
    setSelectedProvince('');
  };

  const handleProvinceChange = (selectedOption) => {
    setSelectedProvince(selectedOption?.value || '');
  };

  const tableRef = useRef(null);
  const handlePrint = () => {
    window.print();
  };

  // Calculate display range
  const startItem = (currentPage - 1) * entriesPerPage + 1;
  const endItem = Math.min(currentPage * entriesPerPage, totalEntries);
  const currentPageData = getCurrentPageData();

  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => navigate(-1)} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Suppliers</h3>
          </div>
        </div>

        <div style={{ marginTop: 12 }} />

        {/* All filters in one line */}
        <div className={classes.topNavBars}>
          <div className={classes.filterRow} style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'nowrap' }}>
            {/* Continent */}
            <div className={classes.inlineField} style={{ minWidth: '200px' }}>
              <label className={classes.inlineLabel}>Continent:</label>
              <Select
                onChange={handleContinentChange}
                options={selectOptions}
                menuPortalTarget={document.body}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: '100%',
                    fontSize: 12,
                  }),
                  control: (provided) => ({
                    ...provided,
                    minHeight: "36px",
                    fontSize: 12,
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontSize: 12,
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    fontSize: 12,
                    backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                    color: "#111827",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: "300px",
                    overflowY: "auto",
                    fontSize: 12,
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                className={classes.inlineSelect}
              />
            </div>

            {/* Region */}
            <div className={classes.inlineField} style={{ minWidth: '200px' }}>
              <label className={classes.inlineLabel}>Region:</label>
              <Select
                onChange={handleRegionChange}
                options={tableData3}
                isDisabled={!selectedContinent}
                menuPortalTarget={document.body}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: '100%',
                    fontSize: 12,
                  }),
                  control: (provided) => ({
                    ...provided,
                    minHeight: "36px",
                    fontSize: 12,
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontSize: 12,
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    fontSize: 12,
                    backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                    color: "#111827",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: "300px",
                    overflowY: "auto",
                    fontSize: 12,
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                className={classes.inlineSelect}
              />
            </div>

            {/* Province */}
            <div className={classes.inlineField} style={{ minWidth: '200px' }}>
              <label className={classes.inlineLabel}>Province:</label>
              <Select
                onChange={handleProvinceChange}
                options={tableData4}
                isDisabled={!selectedRegion}
                menuPortalTarget={document.body}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: '100%',
                    fontSize: 12,
                  }),
                  control: (provided) => ({
                    ...provided,
                    minHeight: "36px",
                    fontSize: 12,
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontSize: 12,
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    fontSize: 12,
                    backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                    color: "#111827",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: "300px",
                    overflowY: "auto",
                    fontSize: 12,
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                className={classes.inlineSelect}
              />
            </div>

            {/* Process Button */}
            <div className={classes.inlineField} style={{ minWidth: '120px' }}>
              <label className={classes.inlineLabel} style={{ visibility: 'hidden' }}>Process</label>
              <button
                className={classes.loanBtn}
                onClick={handleProcess}
                disabled={statLoading}
                style={{ width: '87%', height: '36px' }}
              >
                {statLoading ? <Spinner size="sm" /> : <><img src={run} alt="process" /> Process</>}
              </button>
            </div>

            {/* Search */}
            <div className={classes.inlineField} style={{ minWidth: '250px', flexGrow: 1 }}>
              <label className={classes.inlineLabel}>Search:</label>
              <div className={classes.searchInputWrapper} style={{ width: '100%' }}>
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyPress={handleKeyPress}
                  className={classes.searchInput}
                  placeholder="Search suppliers..."
                  style={{ width: '85%', height: '36px' }}
                />
                <Search className={classes.searchIcon} size={16} />
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 24 }} />

        {/* Suppliers Table */}
        <div className={classes.tableContainer}>
          {statLoading ? (
            <div style={{ textAlign: "center", padding: "40px" }}>
              {/* <Spinner animation="border" variant="primary" /> */}
              <p>Loading suppliers...</p>
            </div>
          ) : currentPageData.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px", fontSize: "18px", color: "#374151" }}>
              <p>No suppliers found</p>
            </div>
          ) : (
            <>
              <div className={classes.sideTools}>
                {currentPageData.length > 0 && (
                  <div className={classes.filterIcons}>
                    <img src={MailLogo} alt="email" className={classes.iconBtns} />
                    <img onClick={handlePrint} src={PrintLogo} alt="print" className={classes.iconBtns} />
                    <img src={DownloadLogo} alt="download" className={classes.iconBtns} />
                  </div>
                )}
              </div>

              <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 20 }}>
                <thead>
                  <tr style={{ borderBottom: "1px solid #d1d5db" }}>
                    <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}>S/N</th>
                    <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}>Name</th>
                    <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}>Email</th>
                    <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}>Phone Number</th>
                    <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}>Created By</th>
                    <th style={{ padding: "8px", textAlign: "center", fontSize: 12 }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentPageData.map((supplier, index) => (
                    <tr key={supplier.id || index} style={{ borderBottom: "1px solid #d1d5db" }}>
                      <td style={{ padding: "8px", fontSize: 12 }}>{startItem + index}</td>
                      <td style={{ padding: "8px", fontSize: 12 }}>{supplier.name || 'N/A'}</td>
                      <td style={{ padding: "8px", fontSize: 12 }}>{supplier.email || 'N/A'}</td>
                      <td style={{ padding: "8px", fontSize: 12 }}>{supplier.phone_number || 'N/A'}</td>
                      <td style={{ padding: "8px", fontSize: 12 }}>{supplier.created_by || 'N/A'}</td>
                      <td style={{ padding: "8px", textAlign: "center", fontSize: 12 }}>
                        <button className={classes.actionBtn} title="View" style={{ border: 'none', background: 'none', padding: '4px' }}>
                          <img src={EyeIcon} alt="View" />
                        </button>
                        <button className={classes.actionBtn} title="Edit" style={{ border: 'none', background: 'none', padding: '4px' }}>
                          <img src={PencilIcon} alt="Edit" />
                        </button>
                        <button className={classes.actionBtn} title="Delete" style={{ border: 'none', background: 'none', padding: '4px' }}>
                          <img src={DeleteIcon} alt="Delete" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination */}
              <div className={classes.paginationStyle}>
                <div className={classes.footerSubOne}>
                  <button
                    className={classes.btnFirst}
                    onClick={handleFirstPage}
                    disabled={currentPage === 1 || benLoading}
                  >
                    First
                  </button>
                  <span className={classes.ftOne}>
                    {getPageNumbers().map(pageNum => (
                      <button
                        key={pageNum}
                        className={`${classes.pageNumber} ${currentPage === pageNum ? classes.active : ''}`}
                        onClick={() => handlePageClick(pageNum)}
                        disabled={benLoading || pageNum === currentPage}
                      >
                        {pageNum}
                      </button>
                    ))}
                  </span>
                  <button
                    className={classes.btnSec}
                    onClick={handleLastPage}
                    disabled={currentPage === totalPages || benLoading}
                  >
                    Last
                  </button>
                </div>
                <p className={classes.displayPag}>
                  {benLoading ? 'Loading...' : `Displaying page ${currentPage} of ${totalPages} (${startItem}-${endItem} of ${totalEntries} suppliers)`}
                </p>
              </div>
            </>
          )}
        </div>
      </div>

      {benLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
    </div>
  );
}

export default Suppliers;